import Cal, { getCalApi } from '@calcom/embed-react'
import { useEffect } from 'react'
import { useTheme } from '#app/routes/resources+/theme-switch.tsx'
import { calComLink } from '#app/utils/constants.ts'
import { cn } from '#app/utils/tailwind-merge.js'

/**
 * Inline Cal.com booker. Theme follows the site preference so the iframe
 * doesn't flash the wrong palette after hydration.
 */
export function CalEmbed({ className }: { className?: string }) {
	const theme = useTheme()
	const calTheme = theme === 'dark' ? 'dark' : 'light'

	useEffect(() => {
		void (async () => {
			const cal = await getCalApi()
			cal('ui', {
				theme: calTheme,
				// Drops the left "André Casal / 30min / Cal Video" panel so the
				// calendar can use the full width.
				hideEventTypeDetails: true,
				layout: 'month_view',
			})
		})()
	}, [calTheme])

	return (
		<div className={cn('min-h-[42rem] w-full', className)}>
			<Cal
				calLink={calComLink}
				style={{ width: '100%', height: '100%', overflow: 'scroll' }}
				config={{
					layout: 'month_view',
					theme: calTheme,
				}}
			/>
		</div>
	)
}
